// extracted by mini-css-extract-plugin
export default {"bookingCon":"contact_bookingCon__lzAZ7","calendar":"contact_calendar__npM30"};